import { FoundationDomain } from '@models';

export interface FoundationDomainsResult {
  foundationDomains: FoundationDomain[];
}
